import { denormalisedResponseEntities } from './data';

export const receiptKey = id => `chatRead_${id.replace(/-/g, '')}`;
export const listingGroup = tx =>
  tx?.listing?.attributes?.publicData?.listingType === 'mandato-compra' ? 'buyers' : 'businesses';

/** Retrieve every page before grouping: filtering a single page would hide conversations. */
export const queryInboxTransactions = async (sdk, params = {}) => {
  let page = 1;
  let totalPages = 1;
  const transactions = [];
  do {
    const response = await sdk.transactions.query({
      ...params,
      include: ['listing', 'customer', 'provider'],
      page,
      perPage: 100,
    });
    transactions.push(...denormalisedResponseEntities(response));
    totalPages = response.data.meta?.totalPages || 1;
    page += 1;
  } while (page <= totalPages);
  return transactions;
};

/** Count unread conversations, never confuse transaction action states with messages. */
export const getConversationActivity = async (sdk, tx, user) => {
  const readAt = Number(user.attributes?.profile?.privateData?.[receiptKey(tx.id.uuid)]) || 0;
  const initialAt = new Date(tx.attributes.createdAt).getTime();
  let unread =
    !!tx.attributes.protectedData?.inquiryMessage &&
    tx.customer?.id.uuid !== user.id.uuid &&
    initialAt > readAt;
  let preview = tx.attributes.protectedData?.inquiryMessage || '';
  let latestAt = initialAt;
  let page = 1;
  let totalPages = 1;
  do {
    const response = await sdk.messages.query({
      transactionId: tx.id,
      include: ['sender'],
      page,
      perPage: 100,
    });
    const messages = denormalisedResponseEntities(response);
    if (page === 1 && messages.length) {
      preview = messages[0].attributes.content || '';
      latestAt = new Date(messages[0].attributes.createdAt).getTime();
    }
    unread =
      unread ||
      messages.some(
        m =>
          !m.attributes.deleted &&
          m.sender?.id.uuid !== user.id.uuid &&
          new Date(m.attributes.createdAt).getTime() > readAt
      );
    totalPages = response.data.meta?.totalPages || 1;
    if (unread || messages.some(m => new Date(m.attributes.createdAt).getTime() <= readAt)) break;
    page += 1;
  } while (page <= totalPages);
  return {
    unread,
    preview,
    latestAt,
    group: listingGroup(tx),
    tab: tx.customer?.id.uuid === user.id.uuid ? 'orders' : 'sales',
  };
};
